import { createContext,useEffect,useReducer } from "react";

export const BusinessAuthContext = createContext();

export const authReducer = (state,action) => {

    switch(action.type)
    {        

        case 'BUSINESS_LOGIN':
            localStorage.setItem("business", JSON.stringify(action.payload));
            return {
                ...state,
                business: action.payload,
            };


        case 'BUSINESS_LOGOUT':
            localStorage.removeItem("business");
            return {
                ...state,
                business: null,
                authChecked: true,
            };  

        case 'UPDATE_BUSINESS':
            const updated = { ...state.business, ...action.payload };
            localStorage.setItem("business", JSON.stringify(updated));
            return { ...state, business: updated };    
      
        case 'AUTH_CHECKED':
            return {
                ...state,
                authChecked: true
            };

        //combines BUSINESS_LOGIN & AUTH_CHECKED to avoid loading issues
        case 'INIT_BUSINESS_AUTH':
            return {
                ...state,
                business: action.payload,
                authChecked: true,
            };
       
        default:
            return state;    
    }
}

export const BusinessAuthContextProvider = ({children}) => {
    const [state,dispatch] = useReducer(authReducer,{
        business:null,
        authChecked: false,
    });

    /*useEffect(()=>{

        const business = JSON.parse(localStorage.getItem('business'));
        if(business){
            dispatch({type:'BUSINESS_LOGIN', payload:business});
        }

        dispatch({ type: "AUTH_CHECKED" });

    },[]);*/

    useEffect(() => {
        try {
            const business = JSON.parse(localStorage.getItem("business"));

            dispatch({
                type: "INIT_BUSINESS_AUTH",
                payload: business || null,
            });
        } catch {
            dispatch({
                type: "INIT_BUSINESS_AUTH",
                payload: null,
            });
        }
    }, []);

    return (
        <BusinessAuthContext.Provider value={{...state,dispatch}}>
            {children}
        </BusinessAuthContext.Provider>
    )
}